import { render } from "./ThePlanosSmall.vue?vue&type=template&id=8d8f0ea0"
import script from "./ThePlanosSmall.vue?vue&type=script&lang=js"
export * from "./ThePlanosSmall.vue?vue&type=script&lang=js"

import "./ThePlanosSmall.vue?vue&type=style&index=0&id=8d8f0ea0&lang=scss"

import exportComponent from "/home/runner/work/topnetms/topnetms/apps/topnetms_site_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__